var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_349_3797)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.46875,
    y: 2.58984,
    width: 34.8672,
    height: 34.8672,
    rx: 8,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.46875,
    y: 2.58984,
    width: 34.8672,
    height: 34.8672,
    rx: 8,
    fill: "url(#paint0_linear_349_3797)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6889 18.1575L33.6916 21.8541C33.6656 22.2062 33.632 22.5579 33.5909 22.909C33.5222 23.4961 33.045 23.9698 32.4456 24.0367C30.5684 24.2466 28.6259 24.2466 26.7488 24.0367C26.1495 23.9698 25.6722 23.4961 25.6035 22.909C25.3792 20.9918 25.3792 19.055 25.6035 17.1378C25.6722 16.5507 26.1495 16.0771 26.7488 16.0101C28.6259 15.8003 30.5684 15.8003 32.4456 16.0101C33.045 16.0771 33.5222 16.5507 33.5909 17.1378C33.6306 17.4772 33.6633 17.8172 33.6889 18.1575ZM29.5972 18.4929C28.7519 18.4929 28.0667 19.1782 28.0667 20.0234C28.0667 20.8687 28.7519 21.5539 29.5972 21.5539C30.4424 21.5539 31.1277 20.8687 31.1277 20.0234C31.1277 19.1782 30.4424 18.4929 29.5972 18.4929Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0699 13.9421C33.2285 14.2168 32.9308 14.5244 32.6155 14.4892C30.6254 14.2668 28.5688 14.2668 26.5786 14.4892C25.2835 14.634 24.236 15.6538 24.0833 16.9601C23.8452 18.9954 23.8452 21.0516 24.0833 23.087C24.236 24.3932 25.2835 25.4131 26.5786 25.5579C28.5688 25.7802 30.6254 25.7802 32.6155 25.5579C32.9328 25.5224 33.2331 25.8322 33.0729 26.1085C32.2785 27.4786 30.8622 28.4348 29.2163 28.608L28.5512 28.678C25.173 29.0334 21.7657 29.01 18.3927 28.6081L17.952 28.5555C16.1336 28.3389 14.6929 26.9182 14.4507 25.1031C14.0008 21.7316 14.0008 18.3154 14.4507 14.9439C14.6929 13.1288 16.1336 11.7081 17.952 11.4915L18.3927 11.439C21.7657 11.037 25.173 11.0136 28.5512 11.3691L29.2163 11.4391C30.8635 11.6124 32.2776 12.5701 33.0699 13.9421Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_349_3797",
    x: 0.657552,
    y: 0.0993302,
    width: 46.4896,
    height: 46.4896,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.32068
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.9056
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.67451 0 0 0 0 0.207843 0 0 0 0 0.623529 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_349_3797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_349_3797",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_349_3797",
    x1: 28.0864,
    y1: 44.4305,
    x2: 2.60998,
    y2: -27.5831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E64067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55653,
    stopColor: "#5926F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4828A0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileWallet);
export default __webpack_public_path__ + "static/media/mobile_wallet.3fda78c997cbc15e8bd0f8e10df74835.svg";
export { ForwardRef as ReactComponent };